import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// The browser tab title, "Applications - Caramel". Names match the sidebar
// and Settings nav; a path not listed here shows just "Caramel".
const PAGE_NAMES: [prefix: string, name: string][] = [
  ["/login", "Log in"],
  ["/onboarding", "Welcome"],
  ["/dashboard/home", "Home"],
  ["/dashboard/tracker", "Applications"],
  ["/dashboard/dreamcompanies", "Dream Companies"],
  ["/dashboard/roles", "New Roles"],
  ["/dashboard/prep", "Interview Prep"],
  ["/dashboard/networking", "Networking"],
  ["/dashboard/applications", "Drafts"],
  ["/dashboard/coldemails", "Cold Emailing"],
  ["/dashboard/coffeechats", "Coffee Chats"],
  ["/settings/profile", "Profile"],
  ["/settings/job-search", "Job Search"],
  ["/settings/plan", "Plan"],
  ["/settings/archives", "Archives"],
  ["/settings", "Settings"],
  ["/cancel", "Checkout canceled"],
];

export default function PageTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    const name = PAGE_NAMES.find(([prefix]) => pathname.startsWith(prefix))?.[1];
    document.title = name ? `${name} - Caramel` : "Caramel";
  }, [pathname]);
  return null;
}
